import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Filter } from 'shared/types/Common'
import { ParamKey } from 'shared/types/QueryModel'

import { FiltersState } from './types'

const initialState: FiltersState = {
  isOpen: false,
  isUseFilters: false,
  filters: {},
}

const FiltersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setIsOpen: (state, { payload }: PayloadAction<boolean>) => {
      state.isOpen = payload
    },
    setIsUseFilters: (state, { payload }: PayloadAction<boolean>) => {
      state.isUseFilters = payload
    },
    setFilters: (state, { payload }: PayloadAction<Filter>) => {
      state.filters = {
        ...state.filters,
        ...payload,
      }
    },
    deleteFilter: (state, { payload }: PayloadAction<ParamKey>) => {
      delete state.filters[payload]
    },
    clearFilters: (state) => {
      state.filters = {}
    },
  },
})

export const FiltersActions = FiltersSlice.actions
export const filtersSlice = FiltersSlice.reducer
